import React, { useState, useEffect } from 'react';
import Naira from 'react-naira';
import './checkout.styles.scss';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  selectCartItems,
  selectCartTotal,
  selectCartItemsCount
} from '../../../../redux-store/reducers/cart-reducer/cart.selector';
import { store } from '../../../../redux-store/store';
import CheckoutItem from './checkout-item/checkout-item.component';
import { useLocation } from 'react-router-dom';
import Popup from '../../../utilities/Popup';
import AddPaymentForm from '../payment/Payments Modals/AddPaymentForm';
import * as BiIcons from "react-icons/bi";
import SelectPayment from '../payment/SelectPayment'
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import BasicModal from './questionModal';

const Checkout = ({
  cartItems,
  total,
  products,
  AddOrders,
  AddCheckOutOrders,
  ClearCart,
  LoadPayments,
  companyId,
  AddPayment,
  categories,
  OrderDetails,
  orderId,
  drop,
  accounts,
  accountTypes,
  paymentTypes,
  cardTypes,
}) => {
  const [openPopup, setOpenPopup] = useState(false);
  const location = useLocation();
  var salesOrders = [];
  var value = {};
  var record = [];
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [vatValue, setVatValue] = useState(0);
  const [discountValue, setDiscountValue] = useState(0);
  const [is_pay, set_is_pay] = useState(false);
  const [addOpenPopup, setAddOpenPopup] = useState(false);


  const vat = (e) => {
    store.dispatch({ type: 'VAT', payload: e.target.value });
    setVatValue(e.target.value)
  }

  const getTotal = () => {
    var newTotal = 0;
    var newvat = vatValue / 100;
    var newDiscount = discountValue / 100;
    var updatedDiscount = newDiscount;
    var total = 0;

    for (var i = 0; i < cartItems.length; i++) {

      var discountTotal = cartItems[i].salesPrice * newDiscount;
      var discountQuantity = discountTotal * cartItems[i].quantity;
      var salesTotal = cartItems[i].salesPrice * cartItems[i].quantity;
      newTotal += salesTotal - discountQuantity;
    }
    var prevvAT = newvat;
    newvat = newvat * newTotal;
    var lastValue = newTotal + newvat;
    store.dispatch({ type: 'DISCOUNT_CAL', payload: newDiscount });
    store.dispatch({ type: 'VAT_CAL', payload: prevvAT });
    return lastValue;
  }



  const discount = (e) => {
    store.dispatch({ type: 'DISCOUNT', payload: e.target.value });
    setDiscountValue(e.target.value)
  }

  const prepareOrder = () => {
    var i = 0;
    for (i; i < cartItems.length; i++) {
      record[i] = {
        quantity: cartItems[i].quantity,
        sku: cartItems[i].sku,
      };
    }
    var value = {
      salesOrders: record,
      transactionReference: cartItems[0]?.transactionReference,
    };
    AddOrders(value);
  };
  
  useEffect(() => {
    console.log(location)
    /*if (orderId != 'null') {
      OrderDetails(orderId);
      store.dispatch({ type: "PERSIST_ORDER", payload: "null" })
    }*/
    LoadPayments(companyId);
    return () => { };
  }, []);
  const addPayment = (payment, resetForm) => {
    var data = {
      ...payment,
      companyId: companyId,
      salesOrders: cartItems,
      vat: localStorage.getItem("vat"),
      discount: localStorage.getItem("discount"),
      transactionReference: cartItems[0]?.transactionReference,
      sendBy: "jokoyoski",
      referenceNumber: "234494932"
    };
    AddPayment(data);
    setRecordForEdit(null);
    setAddOpenPopup(false);

  };

  return (

    <>
      <div className="cart_section container" >
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              {cartItems.length > 0 ? (
                <div className="cart_container">
                  <div className="cart_title"> <strong> Item(s) Available in Cart</strong> </div>
                  {cartItems.map((cartItem) => (
                    <CheckoutItem key={cartItem.id} cartItem={cartItem} />
                  ))}
                  <div className="order_total">
                    <div className="order_total_content text-md-right">
                      <div className="order_total_title"> <strong> Order Total: </strong></div>
                      <div className="order_total_amount"> <h4 className='text-[#3F51B5]'> <strong><Naira>{getTotal()}</Naira></strong> </h4></div>
                    </div>
                  </div>
                  <Box
                    component="form"
                    sx={{
                      '& > :not(style)': { m: 1, width: '25ch' },
                    }}
                    noValidate
                    autoComplete="off"
                  >
                    <div className="pt-2"></div>
                    <TextField onChange={discount} value={discountValue} className="" id="outlined-basic" label="Discount(%)" variant="outlined" />
                    <TextField onChange={vat} value={vatValue} id="outlined-basic" label="VAT(7.5%)" variant="outlined" />
                  </Box>

                  <Popup
                    title="Record Payment"
                    openPopup={addOpenPopup}
                    setOpenPopup={setAddOpenPopup}
                  >

                    <AddPaymentForm
                      recordForEdit={recordForEdit}
                      addOrEdit={addPayment}
                      accounts={accounts}
                      accountTypes={accountTypes}
                      paymentTypes={paymentTypes}
                      cardTypes={cardTypes}
                    />
                  </Popup>
                  {cartItems[0].orderId > 0 ? (

                    <div className="grid grid-cols-2">
                      <div>
                        <button
                          onClick={() => {
                            setAddOpenPopup(true);
                            setRecordForEdit(null);
                          }}
                          className="final-button"
                        >
                          CheckOut
                        </button>
                      </div>

                    </div>

                  ) : (
                    <div className="d-flex mt-3">

                      <BasicModal cartItems={cartItems} drop={drop} amount={getTotal()} />
                    </div>
                  )}

                  <div className="flex space-x-3 justify-end">
                    <Link to="/main/sales">   <button className="px-5 flex items-center space-x-2 shadow-lg py-2 bg-[#3F51B5] rounded-md text-white"> <span>Add More items to cart </span> <BiIcons.BiAddToQueue /></button></Link>
                    {/*<button onClick={() => prepareOrder()} type="button" className="bg-green-500 shadow-lg ml-3 px-5 py-2 rounded-md text-white">Save Order
                    </button>*/}
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>

    </>



  );
};

const mapToDispatchToProps = (dispatch) => ({
  LoadOrders(payload) {
    dispatch({ type: 'LOAD_SALES_PRODUCT_LIST', payload });
  },
  ClearCart: () => dispatch({ type: 'CLEAR_CART' }), //setting the values,
  AddOrders(payload) {
    dispatch({ type: 'SAVE_ORDERS', payload });
  },
  AddCheckOutOrders(payload) {
    dispatch({ type: 'SAVE_ORDERS_FOR_CHECKOUT', payload });
  },
  AddPayment(payload) {
    dispatch({ type: 'ADD_PAYMENT', payload });
  },
  OrderDetails(payload) {
    dispatch({ type: 'LOAD_ORDER_DETAILS', payload });
  },

  LoadPayments(payload) {
    dispatch({ type: 'LOAD_PAYMENT_DETAILS', payload });
  },
  //object we are passing into the component
  // AddItem: (item) => dispatch(AddItem(item)), //setting the values,
});

const mapStateToProps = (state) => {
  return {
    cartItems: selectCartItems(state), // from the selector we pass in the state
    products: state.salesReducer.products,
    total: selectCartTotal(state),
    companyId: state.persistReducer.companyId,
    payments: state.salesReducer.payments,
    drop: state.userReducer.drop,
    accountTypes: state.salesReducer.accountTypes,
    accounts: state.salesReducer.accounts,
    paymentTypes: state.salesReducer.paymentTypes,
    cardTypes: state.salesReducer.cardTypes,
  };
};

export default connect(mapStateToProps, mapToDispatchToProps)(Checkout); //higher order component
